import angular from 'angular';

export default function hpRequired() {
    return {
        require: 'ngModel',
        restrict: 'A',

        link(scope, element, attr, ngModelCtrl) {
            let submitted = false;

            function validateEntry(text) {
                if (angular.isUndefined(submitted)) { // if value isn't entered
                    if (text === '' || text === null) {
                        element.addClass('invalid');
                    } else {
                        element.removeClass('invalid');
                    }
                }

                if (submitted && (text === '' || text === null)) {
                    element.addClass('invalid');
                } else {
                    element.removeClass('invalid');
                }

                return text;
            }

            scope.$watch(attr.hpRequired, (value) => {
                submitted = value;
                validateEntry(element.val());
            });

            scope.$on('submitted', () => {
                submitted = true;
                validateEntry(element.val());
            });

            scope.$on('reset', () => {
                submitted = false;
                validateEntry(element.val());
            });

            ngModelCtrl.$parsers.push(validateEntry);
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/common/angular/directives/hpRequired.directive.js